import { createFileRoute, Navigate } from "@tanstack/react-router";
import { PageHeader, Skeleton } from "@optymyse/suite-ui";
import { workspaceSlug } from "../lib/hosts";
import { useWorkspace } from "../lib/workspaces";
import { strings } from "../lib/strings";
import { ApiError } from "../lib/api";
import { ToWorkspaces } from "../components/workspaces/ToWorkspaces";
import { Page, Panel } from "../components/directory/Page";

/**
 * The workspace's general settings, read-only: a workspace is its organisation's at Optymyse, which is where its
 * name and address, its owners and admins, and closing it are managed.
 */
function GeneralSettingsPage() {
  const slug = workspaceSlug();
  const view = useWorkspace(slug);

  if (view.isLoading) {
    return (
      <Page>
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-40" />
      </Page>
    );
  }
  if (!view.data || view.error instanceof ApiError) return <ToWorkspaces />;
  if (view.data.role !== "administrator") return <Navigate to="/admin" />;

  const { workspace } = view.data;
  const rows: [string, string][] = [
    [strings.workspaces.settings.nameLabel, workspace.name],
    [strings.workspaces.settings.slugLabel, workspace.slug],
    [strings.workspaces.settings.regionLabel, strings.workspaces.settings.regions[workspace.region]],
  ];

  return (
    <Page>
      <PageHeader
        title={strings.workspaces.settings.title}
        description={strings.workspaces.settings.managedAtOptymyse}
      />
      <Panel>
        <dl className="divide-y divide-line">
          {rows.map(([label, value]) => (
            <div key={label} className="flex items-center justify-between gap-4 py-3 first:pt-0 last:pb-0">
              <dt className="text-secondary text-ink-muted">{label}</dt>
              <dd className="font-medium">{value}</dd>
            </div>
          ))}
        </dl>
      </Panel>
    </Page>
  );
}

export const Route = createFileRoute("/admin/settings/")({ component: GeneralSettingsPage });
